<div class="business-banner-top post-box-shadow gs-card gs-banner-root">
  <div class="business-banner gs-banner-shell">
    <div class="banner-shadow"></div>
    <img class="banner-img gs-banner-cover" [ngStyle]="{'background-image': 'url(' + bannerimg.src + ')'}">
    <div class="banner-overlay gs-banner-overlay">
      <div class="banner-edit gs-banner-camera-btn" title="Edit banner" (click)="uploadBannerHere()" style="cursor: pointer;"
        *ngIf="commonVariables?.localUser">
        <input type="file" style="display: none!important;" accept=".jpg,.jpeg, .png" #myFileInput title="Edit banner"
          (click)="myFileInput.value=''"
          (change)="fileChangeEvent($event,template)" />
        <div class="image-upload"></div>
        <ng-icon name="tablerCamera" class="gs-banner-camera" aria-hidden="true"></ng-icon>
      </div>
      <div *ngIf="commonVariables.localUser" class="profile-photo-container gs-banner-avatar" style="position: absolute; bottom: -25px;">
        <div class="profile-photo-wrapper"
             [matMenuTriggerFor]="menu"
             (mouseenter)="onMouseEnter()"
             (mouseleave)="onMouseLeave()">

          <!-- Profile Image -->
          <div *ngIf="infoData.photo != null" class="profile-image-holder">
            <img class="img-small1" style="width: 113px !important; height: 112px !important;" 
            src="{{ profilePhoto?.src }}" alt="Profile photo">
          </div>

          <!-- Initials Circle -->
          <div *ngIf="infoData.photo == undefined" class="profile-image-holder">
            <div class="circles img-small1" style="width: 113px !important; height: 112px !important;" 
              [style.background-color]="getColor(profileitems?.firstName, profileitems?.lastName)">
              <div class="circle-text font-size-50 pad-tp-20" style="font-family:Arial, sans-serif;"

                [style.color]="getTextColor(profileitems?.firstName, profileitems?.lastName)">
                {{ getInitials(profileitems?.firstName, profileitems?.lastName) }}
              </div>
            </div>
          </div>

          <!-- Camera Overlay -->
          <div class="photo-edit-overlay" [class.show]="showImage">
            <div class="camera-icon-wrapper">
              <ng-icon name="tablerCamera"></ng-icon>
              <span class="edit-text">Edit</span>
            </div>
          </div>
        </div>

        <mat-menu #menu="matMenu" class="profile-photo-menu">
          <input #myFileInput2 style="display: none;" type="file" (click)="myFileInput2.value=null"
            (change)="fileChangeEvent2($event, profilePhotoUpload)" accept=".jpg, .jpeg, .png" />
          <button class="mat-menu-height" mat-menu-item (click)="uploadPhotoHere()">
            <span>Change profile photo</span>
          </button>
          <button type="button" (click)="openSweetalert()" class="mat-menu-height" mat-menu-item>
            <span>Remove profile photo</span>
          </button>
        </mat-menu>
      </div>
      <div *ngIf="profilePhoto != undefined &&!commonVariables.localUser" class="gs-banner-avatar" style="position: absolute; bottom: -25px;">
        <img class="img-small1" src="{{profilePhoto?.src}}">
      </div>
      <div *ngIf="profilePhoto == undefined &&!commonVariables.localUser" class="gs-banner-avatar">
        <div style="position: absolute; bottom: -25px;" class="circles img-small1"
          [style.background-color]="getColor(infoData?.firstName, infoData?.lastName)">
          <div class="circle-text font-size-50 pad-tp-20"
            [style.color]="getTextColor(profileitems?.firstName, profileitems?.lastName)">{{
            getInitials(infoData?.firstName, infoData?.lastName) }}
          </div>
        </div>
      </div>

      <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon>
      </button> -->

      <!-- Decorative mirror of the avatar's circle-over-seam curve, right side. -->
      <!-- <div class="gs-banner-avatar-mirror"></div> -->

    </div>
  </div>

  <div class="business-details1 hpanel border-radius-top-left-right-0 gs-banner-body" style="word-wrap: break-word;">
    <div class="col-md-8 banr-detail-pos gs-banner-meta">
      <div *ngIf="this.infoData.userType !== 'student'">
        <p *ngIf="infoData.firstName && infoData.lastName" class="profile-name ellipse2 gs-banner-name"
          title="{{infoData.firstName + ' ' + infoData.lastName}}" data-toggle="tooltip" data-placement="top">
          {{infoData.firstName + " " + infoData.lastName}}
        </p>
        <p title="{{infoData.pitch}}" *ngIf="infoData.pitch" class="profile-tag ellipse1 gs-banner-tag" data-toggle="tooltip"
          data-placement="top">
          <!-- <span>
              <ng-icon name="tablerQuote"></ng-icon>
            </span> -->
          {{infoData.pitch}}
        </p>



        <div *ngIf="isCurrentUser; else otherUser" class="banner-title-details gs-banner-title-row">
          <p *ngIf="currentOrgProvider?.getCurrentOrg?.title" class="profile-others ellipse1 gs-banner-others"
            title="{{currentOrgProvider?.getCurrentOrg?.title}}">
            {{currentOrgProvider?.getCurrentOrg?.title}}
          </p>
          <p *ngIf="currentOrgProvider?.getCurrentOrg?.organisationName" class="profile-others ellipse1 gs-banner-others"
            title="{{currentOrgProvider?.getCurrentOrg?.organisationName}}">
            &#64; {{currentOrgProvider?.getCurrentOrg?.organisationName}}
          </p>
        </div>

        <ng-template #otherUser>
          <div class="banner-title-details gs-banner-title-row">
            <p *ngIf="workExpDetails?.title" class="profile-others ellipse1 gs-banner-others" title="{{workExpDetails?.title}}">
              {{workExpDetails?.title}}
            </p>
            <p *ngIf="workExpDetails?.organisationName" class="profile-others ellipse1 gs-banner-others"
              title="{{workExpDetails?.organisationName}}">
              &#64; {{workExpDetails?.organisationName}}
            </p>
          </div>
        </ng-template>

        <p *ngIf="infoData.city && infoData.state" class="profile-others ellipse1 gs-banner-others"
          title="{{infoData.city + ', ' + infoData.state}}">
          {{infoData.city + ', ' + infoData.state}}
        </p>
      </div>

      <div *ngIf="this.infoData.userType === 'student'">
        <p *ngIf="infoData.firstName && infoData.lastName" class="profile-name ellipse2 gs-banner-name"
          title="{{infoData.firstName + ' ' + infoData.lastName}}" data-toggle="tooltip" data-placement="top">
          {{infoData.firstName + " " + infoData.lastName}}
        </p>
        <p *ngIf="infoData.pitch" class="profile-tag ellipse gs-banner-tag" data-toggle="tooltip" data-placement="top">
          {{infoData.pitch}}
        </p>

        <!-- <p class="profile-others ellipse">

          </p> -->
        <div class="col-sm-1">
        </div>
        <p *ngIf="educationElement.schoolName" class="profile-others ellipse" title="{{educationElement.schoolName}}">
          <span>
            Student &#64;
          </span>
          <span>
            <ng-icon name="tablerSchool"></ng-icon>
          </span>
          {{educationElement.schoolName}}
        </p>

        <p *ngIf="educationElement.city && educationElement.state" class="profile-others"
          title="{{educationElement.city + ', ' + educationElement.state}}">
          {{educationElement.city + ', ' + educationElement.state}}
        </p>
      </div>












    </div>
    <div class="col-md-4 gs-banner-actions-col">
      <div class="pull-right row gs-banner-actions">
        <div class="col-md-1" *ngIf="commonVariables?.localUser">
          <div class="btn-group">
            <div title="Edit personal info" (click)="infoEdit(infoTemplate, null)">
              <button [disabled]="duplicatepopup" id="profileBannerEdit" class="gs-icon-btn">
                <ng-icon name="tablerPencil"></ng-icon>
              </button>
            </div>
          </div>
        </div>



        <div class="iuiy1">
          <div *ngIf="!commonVariables?.localUser">
            <button *ngIf="connected" class="btn primary-btn" (click)="sendMessage($event)">
              Send Message
              <ng-icon name="tablerMail" class="jwsk" aria-hidden="true"></ng-icon>
            </button>
          </div>
          <div *ngIf="!commonVariables?.localUser" style="padding-left: 0px; ">
            <div style="display: flex;" *ngIf="requestPending">
              <div class="btn-group unified-btn" dropdown container="body" placement="bottom right">
                <button type="button" class="btn primary-btn" (click)="accept()">Accept</button>
                <button id="button-split" type="button" dropdownToggle data-toggle="dropdown"
                  class="btn primary-btn dropdown-toggle" aria-controls="dropdown-split">
                  <span><ng-icon name="tablerChevronDown"></ng-icon></span>
                </button>
                <ul id="dropdown-split" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-split">
                  <li role="menuitem"><a class="dropdown-item" (click)="reject()">Reject</a></li>
                </ul>
              </div>
            </div>
            <div *ngIf="notConnected">
              <button [disabled]="duplicateconnects" class="btn primary-btn" (click)="connect()">
                Connect
              </button>
            </div>
            <div *ngIf="requestSent">
              <button class="btn  btn-primary" (click)="cancelConnectionRequest() ">
                Cancel Request
              </button>
            </div>
            <div ngbDropdown *ngIf="connected">
              <div class="btn-group smxv" dropdown>

                <a id="button-animated" dropdownToggle>
                  <img src="assets/icon/icon-vert-thr-dot.png" alt="" srcset="" class="Vthree-dote">
                </a>
                <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu" style="margin-left: -148px;"
                  role="menu" aria-labelledby="basic-link">
                  <li role="menuitem"><a class="dropdown-item" (click)="removeConnection()">Remove Connection</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<ng-template #template>
  <div class="common-header-flex">
    <div>Profile Banner Image</div>
    <button><span class="common-close" aria-hidden="true" (click)="closePhoto()">&times;</span></button>
  </div>

  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4.5 / 1"
      format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"></image-cropper>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="closePhoto()">Cancel</button>
        <button class="btn btn-primary" (click)="imageLoaded()">Apply</button>
      </div>
    </div>
  </div>



</ng-template>

<ng-template #profilePhotoUpload>

  <div class="common-header-flex">
    <div>Profile Photo</div>
    <button>
      <span class="common-close" (click)="closePhoto2()">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4"
      format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"></image-cropper>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="closePhoto2()">Cancel</button>
        <button class="btn btn-primary" (click)="imageLoaded2()">Apply</button>
      </div>
    </div>
  </div>

</ng-template>




<ng-template #infoTemplate>

  <div *ngIf="medPrompt == false && studPrompt == false && !otpValidForm ">

    <div class="common-header-flex">
      <div>Personal Details</div>
      <button>
        <span class="common-close" (click)="decline()">&times;</span>
      </button>

    </div>

    <div class="panel-body custom-modal-body">
      <div>
        <form [formGroup]="personalInfoForm">
          <div class="container-fluid app-form form-horizontal">
            <div class="row">
              <div class="form-group">
                <div class="col-sm-3" style="padding-left: 41px;">
                  <img *ngIf="photoId !== undefined && photoId !== null" alt="logo" class="rc" [src]="img4.src">

                  <div *ngIf="photoId === undefined || photoId === null" class="circle-text prof-logo"
                    [style.color]="getTextColor(profileitems?.firstName, profileitems?.lastName)"
                    [style.background-color]="getColor(profileitems?.firstName, profileitems?.lastName)">

                    {{getInitials(profileitems?.firstName, profileitems?.lastName) }}

                  </div>
                </div>
                <div class="col-sm-8">
                  <label for="userType" class="control-label required-field font-light">I am</label>

                  <select class="form-control input-sm" formControlName="userType" id="userType1"
                    (change)="onChangeIam($event.target.value)" open>
                    <option value="null" selected>
                      Choose your user type</option>

                    <option title="Recruiter can create jobs on the platform to attract consultants" value="RECRUITER">
                      Recruiter </option>
                    <option title="Bench Recruiter can create consultants on the platform to attract jobs"
                      value="BENCH_RECRUITER">Bench Sales Recruiter </option>
                    <option title="Management Talent Acquisition can create consultants on the platform to attract jobs"
                      value="MANAGEMENT_TALENT_ACQUISITION">Management Talent Acquisition </option>
                    <option title="Freelance Recruiter can create jobs." value="FREELANCE_RECRUITER">Freelance
                      Recruiter</option>
                    <option title="Job Seeker can look up for jobs posted by recruiters" value="JOB_SEEKER">Job Seeker
                    </option>
                  </select>
                  <div *ngIf="p.userType.invalid && (p.userType.dirty || p.userType.touched)" class="error-msg">
                    <div *ngIf="p.userType.errors.required"> This field is required</div>
                  </div>
                  <div *ngIf="commonVariables?.previousFlag" class="error-msg">
                    <div>Change your user type here</div>
                  </div>
                </div>
              </div>
            </div>



            <div class="row">
              <div class="form-group">
                <label class="col-sm-3 control-label required-field font-light">First Name</label>
                <div class="col-sm-8">
                  <input type="text" maxlength="21" class="form-control input-sm" placeholder="First Name"
                    formControlName="firstName">
                  <div *ngIf="p.firstName.invalid && (p.firstName.dirty || p.firstName.touched)" class="error-msg">
                    <div *ngIf="p.firstName.errors.required">First Name is required</div>
                    <div *ngIf="p.firstName.errors.pattern" style="color: #c3002f;">
                      {{FORMERROR.FIRSTNAME_VALID}}
                    </div>
                    <div *ngIf="p.firstName.errors.minword" style="color: #c3002fed;">
                      {{FORMERROR.FIRSTNAME_MIN}}
                    </div>
                    <div *ngIf="p.firstName.errors.maxword" style="color: #c3002fed;">
                      {{FORMERROR.FIRSTNAME_MAX}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group">
                <label class="col-sm-3 control-label required-field font-light">Last Name</label>
                <div class="col-sm-8">
                  <input type="text" maxlength="41" class="form-control input-sm" placeholder="Last Name"
                    formControlName="lastName">
                  <div *ngIf="p.lastName.invalid && (p.lastName.dirty || p.lastName.touched)" class="error-msg">
                    <div *ngIf="p.lastName.errors.required">Last Name is required</div>
                    <div *ngIf="p.lastName.errors.pattern" style="color:  #c3002f;">
                      {{FORMERROR.LASTNAME_VALID}}
                    </div>
                    <div *ngIf="p.lastName.errors.minword" style="color: #c3002f;">
                      {{FORMERROR.LASTNAME_MIN}}
                    </div>
                    <div *ngIf="p.lastName.errors.maxword" style="color: #c3002f;">
                      {{FORMERROR.LASTNAME_MAX}}
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="form-group">
                <label class="col-sm-3 control-label  font-light">Pitch</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control input-sm" placeholder="Pitch" formControlName="pitch">
                  <div class="error-msg" *ngIf="p.pitch.invalid ">
                    <div *ngIf="p.pitch.errors.maxchar">
                      {{FORMERROR.PITCH_MAX}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group">
                <label style="text-align: right;" class="col-sm-3 control-label font-light">Photo</label>
                <div class="col-sm-8">
                  <input id="myFileInput" input formControlName="photo" title="Choose a photo"
                    placeholder="Choose a photo" type="file" accept=".jpg, .jpeg, .png" class="form-control"
                    #myFileInput3
                    (click)="myFileInput3.value=''"
                    (change)="fileChangeEvent1($event, templateNested)" />
                  <ng-template #templateNested>


                    <div class="common-header-flex">
                      <div>Profile Photo</div>
                      <button><span class="common-close" (click)="closeImage()"
                          aria-hidden="true">&times;</span></button>
                    </div>


                    <div class="modal-body">
                      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                        [aspectRatio]="4   / 4" format="png,jpeg" (imageCropped)="imageCropped($event)"
                        (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()">

                      </image-cropper>
                    </div>


                    <div class="custom-panel-footer">
                      <div class="panel-footer">
                        <div class="footer-flex">
                          <button class="btn btn-default" (click)="closeImage()">Cancel</button>
                          <button class="btn btn-primary" (click)="imageLoaded1()">Apply</button>
                        </div>
                      </div>
                    </div>

                  </ng-template>



                </div>
              </div>
            </div>

            <div class="row"
              *ngIf="infoData.userType != 'student' && infoData.userType != 'JOB_SEEKER' && infoData.userType != 'FREELANCE_RECRUITER'">
              <div class="form-group">
                <label for="title" class="col-sm-3 control-label required-field text-right font-light">Current
                  Organization
                  Type</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control input-sm" placeholder="current Organization Type"
                    formControlName="clientType">
                  <!-- <select class="form-control input-sm" disabled formControlName="clientType" type="text"
                      [ngClass]="{ 'is-invalid': p.clientType.hasError }">
                      <option value="null" selected disabled>Organization Type</option>
                      <option *ngFor="let clientType of clientTypeList" [value]="clientType">
                        {{clientType}}</option>
                    </select> -->
                  <!-- <div *ngIf="p.clientType.invalid && (p.clientType.dirty || p.clientType.touched)" class="error-msg">
                      <div *ngIf="p.clientType.errors.required"> This field is required</div>
                    </div> -->
                  <!-- <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['clientType'].hasError ||
                                  getWorkFormGroup(i).controls['clientType'].hasError &&
                                  (getWorkFormGroup(i).controls['clientType'].dirty ||
                                  getWorkFormGroup(i).controls['clientType'].touched) " class="error-msg">
                      <div *ngIf="getWorkFormGroup(i).controls['clientType'].hasError('required')">Organization Type is
                        required</div>
                    </div> -->

                  <!-- <div style="color:#c3002f; font-weight:500; text-align: justify;"
                      *ngIf="getWorkFormGroup(i).controls['clientType'].hasError('clientTypeMismatch')">You've chosen a
                      different
                      organization type than what you chose while signing up. Please note that credit consumptions are dependent
                      on the type of organization chosen.</div> -->
                  <!-- <div class="row" style="float:right;margin-right: 0px;">
                      <button class="btn btn-primary clitntypebtn" (click)="overRideclient()"
                        *ngIf="getWorkFormGroup(i).controls['clientType'].hasError('clientTypeMismatch')">Change Organization
                        Type</button>
                    </div> -->

                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group">
                <label for="phoneNo" class="col-sm-3 control-label required-field font-light">Phone</label>
                <div class="col-sm-8">
                  <input type="text" maxlength="16" class="form-control input-sm" placeholder="Phone"
                    formControlName="phoneNo">
                  <div class="error-msg" *ngIf="p.phoneNo.invalid">
                    <div *ngIf="p.phoneNo.errors.required">
                      Phone is required
                    </div>
                    <div *ngIf="p.phoneNo.errors.minword && !p.phoneNo.errors.pattern">
                      {{FORMERROR.PHONE_MIN}}
                    </div>
                    <div *ngIf="p.phoneNo.errors.maxword">
                      {{FORMERROR.PHONE_MAX}}
                    </div>
                    <div *ngIf="p.phoneNo.errors.pattern">
                      {{FORMERROR.NUMBER_PATTERN}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group">
                <label for="username" class="col-sm-3 control-label required-field font-light">Primary
                  Email ID</label>
                <div class="col-sm-8">
                  <input type="email" class="form-control input-sm" placeholder="Primary Email ID"
                    formControlName="email">
                  <div *ngIf="p.email.invalid && (p.email.dirty || p.email.touched)" class="error-msg">
                    <div *ngIf="p.email.errors.required">Primary Email ID is required</div>
                    <div *ngIf="p.email.errors.email"> Please enter a valid Email ID</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group">
                <label for="secondaryEmail" class="col-sm-3 control-label font-light">Secondary Email
                  ID</label>
                <div class="col-sm-8">
                  <input type="email" maxlength="51" class="form-control input-sm"
                    (input)="emailidcehck($event.target.value)" (input)="onSecondaryEmailInput($event)"
                    placeholder="Secondary Email ID" trim="blur" formControlName="secondaryEmail"
                    id='highlightSecondary'>
                  <div *ngIf="p.secondaryEmail.invalid" class="error-msg">

                    <!-- Show pattern error only if alreadyExists is not true -->
                    <div *ngIf="p.secondaryEmail.errors?.pattern && p.secondaryEmail.errors?.alreadyExists !== true">
                      {{ FORMERROR.EMAIL_VALID }}
                    </div>

                    <div *ngIf="p.secondaryEmail.errors?.alreadyExists === true">
                      Secondary Email already used by a different user
                    </div>

                    <div *ngIf="p.secondaryEmail.errors.maxword">
                      {{FORMERROR.EMAIL_MAX}}
                    </div>
                    <div *ngIf="p.secondaryEmail.errors.mustMatch">Secondary Email cannot be the
                      same as Primary Email
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group">
                <label class="control-label col-sm-3 required-field font-light">Location</label>
                <div class="col-sm-8">
                  <div class="row form-group">
                    <div class="col-sm-6">
                      <select class="form-control input-sm" formControlName="country"
                        (change)="onChangeCountry($event.target.value, 'user', 'user')">
                        <option value=null selected disabled>Country</option>
                        <option *ngFor="let country of countryList" [value]="country.countryCode">
                          {{country.countryName}}</option>

                      </select>
                      <div *ngIf="p.country.invalid && (p.country.dirty || p.country.touched)" class="error-msg">
                        <div *ngIf="p.country.errors.required"> Country is required</div>
                      </div>
                    </div>
                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='US'">
                      <input type="text" maxlength="12" (keypress)="digitKeyOnly($event)" class="form-control input-sm"
                        placeholder="Zipcode" (keyup)="onKeyZip($event,'user', 'user')" formControlName="zipcode">
                      <div *ngIf="personalInfoForm.value.country=='US'&&( p.zipcode.invalid ||
                                   p.zipcode.invalid && (p.zipcode.dirty ||
                                    p.zipcode.touched))" class="error-msg">
                        <div *ngIf="p.zipcode.errors.required"> Zipcode is required</div>
                        <div *ngIf="p.zipcode.errors.invalid"> Invalid zipcode </div>
                        <div *ngIf="p.zipcode.errors?.minword">
                          {{FORMERROR.ZIPCODE_MIN}}
                        </div>
                        <div *ngIf="p.zipcode.errors?.maxword">
                          {{FORMERROR.ZIPCODE_MAX}}
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='IN'">
                      <select class="form-control input-sm" formControlName="state" type="text">
                        <option value="null" selected disabled>State</option>
                        <option *ngFor="let state of stateListIN" [value]="state.stateName">
                          {{state.stateName}}</option>
                      </select>
                      <div *ngIf="personalInfoForm.value.country=='IN'&&( p.state.invalid ||
                                          p.state.invalid && (p.state.dirty ||
                                           p.state.touched))" class="error-msg">
                        <div *ngIf="p.state.errors.required"> State is required</div>
                      </div>
                    </div>
                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='CA'">
                      <select class="form-control input-sm" formControlName="state" type="text">
                        <option value="null" selected disabled>State</option>
                        <option *ngFor="let state of stateListCA" [value]="state.stateName">
                          {{state.stateName}}</option>
                      </select>
                      <div *ngIf="personalInfoForm.value.country=='CA'&&( p.state.invalid ||
                                      p.state.invalid && (p.state.dirty ||
                                       p.state.touched))" class="error-msg">
                        <div *ngIf="p.state.errors.required"> State is required</div>
                      </div>
                    </div>
                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='AU'">
                      <select class="form-control input-sm" formControlName="state" type="text">
                        <option value="null" selected>State</option>
                        <option *ngFor="let state of stateListAU" [value]="state.stateName">
                          {{state.stateName}}</option>
                      </select>
                      <div *ngIf="personalInfoForm.value.country=='AU'&&( p.state.invalid ||
                                  p.state.invalid && (p.state.dirty ||
                                   p.state.touched))" class="error-msg">
                        <div *ngIf="p.state.errors.required"> State is required</div>
                      </div>
                    </div>
                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country!='AU'&&
                                                            personalInfoForm.value.country!='CA'&&
                                                            personalInfoForm.value.country!='IN'&&
                                                            personalInfoForm.value.country!='US'">
                      <input formControlName="state" maxlength="51" class="form-control input-sm" placeholder="State">
                      <div *ngIf="personalInfoForm.value.country!='AU'&&
                                            personalInfoForm.value.country!='CA'&&
                                            personalInfoForm.value.country!='IN'&&
                                            personalInfoForm.value.country!='US'&&( p.state.invalid ||
                                            p.state.invalid && (p.state.dirty ||
                                            p.state.touched))" class="error-msg">
                        <div *ngIf="p.state.errors.required">
                          State is required
                        </div>
                        <div *ngIf="p.state.errors.maxword">
                          {{FORMERROR.STATE_MAX}}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row">
                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='US'">
                      <input type="text" maxlength="51" placeholder="City" formControlName="city"
                        class="form-control input-sm">
                      <div *ngIf=" p.city.invalid || p.city.invalid && (p.city.dirty || p.city.touched)"
                        class="error-msg">
                        <div *ngIf="p.city.errors.required">
                          {{FORMERROR.CITY_MAX}}
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country!='US'">
                      <input type="text" maxlength="51" placeholder="City" formControlName="city"
                        class="form-control input-sm">
                      <div *ngIf=" p.city.invalid || p.city.invalid && (p.city.dirty || p.city.touched)"
                        class="error-msg">
                        <div *ngIf="p.city.errors.required">
                          City is required
                        </div>
                        <div *ngIf="p.city.errors.maxword">
                          {{FORMERROR.CITY_MAX}}
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='US'">
                      <input formControlName="state" maxlength="51" class="form-control input-sm" placeholder="State">
                      <div *ngIf="personalInfoForm.value.country=='US'&&( p.state.invalid ||
                                              p.state.invalid && (p.state.dirty ||
                                              p.state.touched))" class="error-msg">
                        <div *ngIf="p.state.errors.required">
                          State is required
                        </div>
                        <div *ngIf="p.state.errors.maxword">
                          {{FORMERROR.STATE_MAX}}
                        </div>

                      </div>
                    </div>

                    <div class="col-sm-6" *ngIf="personalInfoForm.value.country!='US'">
                      <input type="text" maxlength="12" (keypress)="digitKeyOnly($event)" class="form-control input-sm"
                        placeholder="Zipcode" formControlName="zipcode">
                      <div *ngIf="personalInfoForm.value.country!='US'&&( p.zipcode.invalid ||
                                       p.zipcode.invalid && (p.zipcode.dirty ||
                                        p.zipcode.touched))" class="error-msg">
                        <div *ngIf="p.zipcode.errors.required"> Zipcode is required</div>
                        <div *ngIf="p.zipcode.errors?.minword">
                          {{FORMERROR.ZIPCODE_MIN}}
                        </div>
                        <div *ngIf="p.zipcode.errors?.maxword">
                          {{FORMERROR.ZIPCODE_MAX}}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button class="btn btn-default " (click)="decline()">
            Cancel
          </button>
          <button *ngIf="!weird" class="btn primary-btn " (click)="infoSave()" [disabled]="!personalInfoForm.valid">
            Submit
          </button>
          <button class="btn primary-btn " *ngIf="weird" (click)="onChangePhysician1()"
            [disabled]="!personalInfoForm.valid">
            Submit
          </button>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="otpValidForm">
    <div class="common-header-flex">
      <div>Authenticate Secondary Email Address</div>
      <button>
        <span class="common-close" (click)="closeOTP()">&times;</span>
      </button>
    </div>

    <div class="panel-body">
      <div class="col-sm-12">

        <div class="alert alert-info addd-dngr">
          An authentication code has been sent to your Secondary email. Please, enter it below.
        </div>

        <form [formGroup]="OtpForm">
          <label class="control-label required-field font-bold">Enter OTP</label>
          <input type="text" placeholder="Enter OTP Code" formControlName="domainValidationOtp"
            class="form-control input-sm" />

          <div class="red"
            *ngIf="OtpControls.domainValidationOtp.invalid &&  (OtpControls.domainValidationOtp.dirty || OtpControls.domainValidationOtp.touched )">
            <div class="error-msg" *ngIf="OtpControls.domainValidationOtp.errors?.required">
              Please Enter OTP
            </div>
            <div class="error-msg" *ngIf="OtpControls.domainValidationOtp.errors?.pattern">
              Enter Only Numbers
            </div>
            <div class="error-msg" *ngIf="OtpControls.domainValidationOtp.errors?.wrongDomainValidationOtp">
              Incorrect OTP. Enter the right one.
            </div>
          </div>

        </form>

        <div>
          <p class="mr-tp-10 OtpDesign" style="color: unset; text-decoration: none;" *ngIf="(resentOTPCode | async) ">
            Resend OTP in <countdown [config]="{ leftTime: 30, format: 'ss' }"></countdown> seconds</p>
          <p class="OtpDesign" *ngIf="!(resentOTPCode | async)" (click)="resendOtp(true)">
            Resend OTP</p>
        </div>


      </div>
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button class="btn btn-default" (click)="closeOTP()"> Cancel </button>
          <button class="btn  btn-primary" (click)="submitOtp()"> Submit </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="modal-dialog "> -->
  <div class="panel-body" *ngIf="medPrompt">
    <div style="justify-content: center; display: flex; padding: 10px;">
      <img style="height: 80px; width: 80px;" src="assets/icon/warning.png">
    </div>
    <div class="text-center"><label>Are you sure?</label></div>
    <div style="padding: 0px 0px 0px 22px; justify-content: center; display: flex">
      <p>Changing to {{"'" + userTypeValue + "'"}} user type requires your work experience. If you hadn't
        provided your
        work experience details, on submitting the
        form you will be asked to fill your work experience. Do you wish to continue?
      </p><br>
    </div>
    <div class="row" style="padding: 10px;">
      <div class="col-sm-6">
        <button (click)="hidePhyPrompt()" class="btn btn-default btn-block">Cancel</button>
      </div>
      <div class="col-sm-6">
        <button (click)="changeToPhysician()" class="btn primary-btn btn-block">Continue</button>
      </div>
    </div>
  </div>
  <!-- </div> -->

  <!-- <div class="modal-dialog"> -->
  <div class="panel-body" *ngIf="studPrompt">
    <div style="justify-content: center; display: flex; padding: 10px;">
      <img style="height: 80px; width: 80px;" src="assets/icon/warning.png">
    </div>
    <div class="text-center"><label>Are you sure?</label></div>
    <div style="padding: 0px 0px 0px 22px; justify-content: center; display: flex">
      <p>Changing to 'Student (Medical/ Healthcare)' user type requires your education
        qualifications. If you
        hadn't provided your education details already, on submitting the
        form you will be asked to fill your education details. Do you wish to continue?
      </p><br>
    </div>
    <div class="row" style="padding: 10px;">
      <div class="col-sm-6">
        <button (click)="hideStudPrompt()" class="btn btn-default btn-block">Cancel</button>
      </div>
      <div class="col-sm-6">
        <button (click)="changeToStudent()" class="btn primary-btn btn-block">Continue</button>
      </div>
    </div>
  </div>
  <!-- </div> -->


</ng-template>

<!-- <ng-template #physicianPrompTemplate>
  <div class="modal-dialog ">
    <div class="modal-content">
      <div style="justify-content: center; display: flex; padding: 10px;">
        <img style="height: 80px; width: 80px;" src="assets/icon/warning.png">
      </div>
      <div class="text-center"><label>Are you sure?</label></div>
      <div class="modal-body" style="padding: 0px 0px 0px 22px; justify-content: center; display: flex">
        <p>Changing to {{"'" + userTypeValue + "'"}} user type requires your work experience. If you hadn't
          provided your
          work experience details, on submitting the
          form you will be asked to fill your work experience. Do you wish to continue?
        </p><br>
      </div>
      <div class="row" style="padding: 10px;">
        <div class="col-sm-6">
          <button (click)="hidePhyPrompt()" class="btn btn-default btn-block">Cancel</button>
        </div>
        <div class="col-sm-6">
          <button (click)="changeToPhysician()" class="btn primary-btn btn-block">Continue</button>
        </div>
      </div>
    </div>
  </div>
</ng-template> -->


<!-- <ng-template #studentPrompTemplate>
  <div class="modal-dialog">
    <div class="modal-content">
      <div style="justify-content: center; display: flex; padding: 10px;">
        <img style="height: 80px; width: 80px;" src="assets/icon/warning.png">
      </div>
      <div class="text-center"><label>Are you sure?</label></div>
      <div class="modal-body" style="padding: 0px 0px 0px 22px; justify-content: center; display: flex">
        <p>Changing to 'Student (Medical/ Healthcare)' user type requires your education
          qualifications. If you
          hadn't provided your education details already, on submitting the
          form you will be asked to fill your education details. Do you wish to continue?
        </p><br>
      </div>
      <div class="row" style="padding: 10px;">
        <div class="col-sm-6">
          <button (click)="hideStudPrompt()" class="btn btn-default btn-block">Cancel</button>
        </div>
        <div class="col-sm-6">
          <button (click)="changeToStudent()" class="btn primary-btn btn-block">Continue</button>
        </div>
      </div>
    </div>
  </div>
</ng-template> -->

<ng-template #photoDeleteTemplate>
  <button type="button" style="font-size: 31px;padding-right: 17px;padding-top: 7px;font-weight: 400;"
    class="close pull-right" aria-label="Close" (click)="no()">
    <span aria-hidden="true">&times;</span>
  </button>
  <label style="margin: 6px 10px 14px 10px;padding-top:10px">Remove Profile Photo</label>
  <hr style="margin: 0px !important;">
  <div class="modal-body ">
    <div class="text-left">
      <p>Are you sure you want to delete the profile photo?</p>
    </div>
    <div class="text-right">
      <button type="button" class="btn btn-default" (click)="no()">No</button>
      <button type="button" class="btn btn-primary" (click)="yes()" style="margin-left: 0.5rem;">Yes</button>
    </div>
  </div>
</ng-template>